import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../assets/contexts/ThemeContext';
import MenuTree from './MenuTree';
import HeaderToolbar from '../../sites/default/layouts/HeaderToolbar';
import { resolveHeaderLogoTagText } from '../../assets/utils/comm/headerLocalized';

/**
 * 좌측 네비게이션 컴포넌트
 * 원본 navigation-left.html과 동일한 구조
 */
const NavigationLeft = ({ menuData }) => {
  const themeContext = useTheme();
  const themeConfig = themeContext?.themeConfig || {};
  const { i18n } = useTranslation();
  const headerLogo = themeConfig.headerLogo || { type: 'image', image: '/assets/images/logo/logo.png' };

  const renderLogo = () => {
    // 태그 타입인 경우 (다국어: title/subtitle이 { kor, eng } 객체일 수 있음)
    if (headerLogo.type === 'tag' && headerLogo.tag) {
      const tag = headerLogo.tag;
      const logoStyle = tag.logo || {};
      const { title: displayTitle, subtitle: displaySubtitle } = resolveHeaderLogoTagText(
        tag,
        i18n.language
      );

      return (
        <div className="header-logo-tag-container">
          <div
            className="header-logo-tag-circle"
            style={{
              width: `${logoStyle.size || 49}px`,
              height: `${logoStyle.size || 49}px`,
              background: logoStyle.backgroundColor || 'linear-gradient(135deg, #9333ea 0%, #3b82f6 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <span
              className="header-logo-tag-letter"
              style={{
                fontSize: logoStyle.fontSize || '1.5rem',
                fontWeight: 'bold',
                color: logoStyle.color || '#ffffff'
              }}
            >
              {logoStyle.letter || 'G'}
            </span>
          </div>
          <div className="header-logo-tag-text-container">
            {(displayTitle != null && displayTitle !== '') && (
              <h3
                className="header-logo-tag-title"
                style={{
                  color: tag.titleColor || '#ffffff',
                  fontSize: tag.titleStyle?.fontSize || '20px',
                  fontWeight: tag.titleStyle?.fontWeight || 700,
                  lineHeight: tag.titleStyle?.lineHeight || 1.2,
                  letterSpacing: tag.titleStyle?.letterSpacing || '0',
                  textTransform: tag.titleStyle?.textTransform || 'none',
                  margin: 0,
                  marginBottom: (displaySubtitle != null && displaySubtitle !== '') ? '4px' : 0
                }}
              >
                {displayTitle}
              </h3>
            )}
            {(displaySubtitle != null && displaySubtitle !== '') && (
              <p
                className="header-logo-tag-subtitle"
                style={{
                  color: tag.subtitleColor || '#999999',
                  fontSize: tag.subtitleStyle?.fontSize || '14px',
                  fontWeight: tag.subtitleStyle?.fontWeight || 400,
                  lineHeight: tag.subtitleStyle?.lineHeight || 1.5,
                  letterSpacing: tag.subtitleStyle?.letterSpacing || '0',
                  textTransform: tag.subtitleStyle?.textTransform || 'none',
                  margin: 0
                }}
              >
                {displaySubtitle}
              </p>
            )}
          </div>
        </div>
      );
    }

    // 이미지 타입인 경우 (기본)
    return (
      <img
        src={headerLogo.image || '/assets/images/logo/logo.png'}
        alt="logo"
      />
    );
  };

  return (
    <aside className="nav-layout nav-layout-left" id="nav-layout-left" aria-label="Left Navigation">
      <div className="nav-layout__inner">
        <div className="nav-layout__logo">
          <Link to="/">
            {renderLogo()}
          </Link>
        </div>
        <div className="nav-layout__menu">
          <nav>
            {menuData && menuData.length > 0 ? (
              <MenuTree items={menuData} level={0} />
            ) : null}
          </nav>
        </div>
        <HeaderToolbar variant="nav" />
      </div>
    </aside>
  );
};

export default NavigationLeft;

